import { render, staticRenderFns } from "./PaymentOrderBankAccountForm.vue?vue&type=template&id=31117942&lang=pug&"
import script from "./PaymentOrderBankAccountForm.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderBankAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports